/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { MainStatisticsDto } from './mainStatisticsClient.typings';
import apiClient from '../apiClient';

function getMainStatistics(): Promise<MainStatisticsDto> {
    return apiClient.get<MainStatisticsDto>('1.0.0/dashboard/counters');
}

export const mainStatisticsClient = {
    getMainStatistics,
};
